import Template from "@/components/Home/Home.template.vue";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  mixins: [Template]
})
export default class Home extends Vue {
  @State("user", { namespace: "authModule" }) public user!: object;

  private mounted() {
    window.location.href = `${process.env.VUE_APP_OAUTH_URL}/login?client_id=${
      process.env.VUE_APP_OAUTH_CLIENT_ID
    }&redirect_uri=${
      process.env.VUE_APP_CORE_FRONTEND
    }/oauth/callback&response_type=code&scope=${encodeURI(
      process.env.VUE_APP_OAUTH_SCOPES
    )}`;
  }
}
